// import { createBrowserInspector } from '@statelyai/inspect';
import { createActorContext } from '@xstate/react';

import { partnerApplicationMachine } from './partner-application-machine';

// const inspector = createBrowserInspector();

export const PartnerApplicationMachineContext = createActorContext(
  partnerApplicationMachine
  // {
  //   inspect: inspector.inspect,
  // }
);
